import { useMemo } from 'react';

import Analytics from '@hh.ru/analytics-js';
import { ElementSpyInstance } from 'bloko/common/elementSpy';

import { useSelector } from 'src/hooks/useSelector';
import { CurrentGeoFilter } from 'src/models/search/common/geoDrawer';
import { ClusterKey } from 'src/types/search/common/clusters';

export const useGeoFiltersAnalytics = () => {
    const employerId = useSelector((state) => state.employerId) || '';
    const employerManagerId = useSelector((state) => state.employerManager?.id) || '';

    return useMemo(() => {
        const analyticParams = { employerId, employerManagerId };
        return {
            sendEventGeoDraftOpen: (hhtmSourceLabel: string) =>
                Analytics.sendHHEventButtonClick('search_resume_geo_draft_open', {
                    ...analyticParams,
                    hhtmSourceLabel,
                }),
            sendEventGeoDraftClose: () =>
                Analytics.sendHHEventButtonClick('search_resume_geo_draft_close', analyticParams),
            sendEventGeoDraftSubmit: () =>
                Analytics.sendHHEventButtonClick('search_resume_geo_draft_submit', analyticParams),
            sendEventGeoDraftReset: (type: CurrentGeoFilter) =>
                Analytics.sendHHEventButtonClick('search_resume_geo_draft_reset', { ...analyticParams, type }),
            sendEventGeoDraftApplyOneArea: (type: CurrentGeoFilter) =>
                Analytics.sendHHEventButtonClick('search_resume_geo_draft_apply_one_area', { ...analyticParams, type }),
            sendEventDeleteHeaderChip: (type: ClusterKey, value: string) =>
                Analytics.sendHHEventButtonClick('search_resume_geo_delete_header_chip', {
                    ...analyticParams,
                    type: type.toUpperCase(),
                    value,
                }),
            sendEventShowAreaFilter: (element: HTMLElement): ElementSpyInstance =>
                Analytics.sendHHEventElementShown(element, {
                    ...analyticParams,
                    name: 'search_resume_geo_area_filter',
                }),
            sendEventShowMetroFilter: (element: HTMLElement): ElementSpyInstance =>
                Analytics.sendHHEventElementShown(element, {
                    ...analyticParams,
                    name: 'search_resume_geo_metro_filter',
                }),
            sendEventShowDistrictFilter: (element: HTMLElement): ElementSpyInstance =>
                Analytics.sendHHEventElementShown(element, {
                    ...analyticParams,
                    name: 'search_resume_geo_district_filter',
                }),
            sendEventSearchAreas: () => Analytics.sendHHEvent('search_resume_geo_search_areas', analyticParams),
            sendEventSearchDistricts: () => Analytics.sendHHEvent('search_resume_geo_search_districts', analyticParams),
            sendEventSearchMetro: () => Analytics.sendHHEvent('search_resume_geo_search_metro', analyticParams),
        };
    }, [employerId, employerManagerId]);
};
